import { cn } from '../../lib/utils';

/**
 * Segmented control (docs/DESIGN.md §4): a bordered surface with 4px padding; the active segment
 * is solid (text color background), the others transparent and muted.
 */
export function Segmented<T extends string>({
  label,
  options,
  value,
  onChange,
  compact = false,
}: {
  label: string;
  /** Smaller text and padding, for four options on a 360px screen. */
  compact?: boolean;
  options: readonly { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
}) {
  return (
    <div
      role="group"
      aria-label={label}
      className="grid auto-cols-fr grid-flow-col gap-1 rounded-[18px] border border-line bg-surface p-1"
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          aria-pressed={value === o.value}
          onClick={() => onChange(o.value)}
          className={cn(
            'min-h-11 rounded-[14px] font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-accent',
            compact ? 'px-1 text-[13px]' : 'px-3 text-[15px]',
            value === o.value ? 'bg-fg text-bg' : 'text-muted hover:text-fg',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
